import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { Container, Col, Row, Button, Dropdown, Form } from "react-bootstrap";
import { SXModalBase } from "./SXModal";
import { useTranslation } from "react-i18next";
import { openModal, closeModal, selectModalById } from "../../features/ui/uiSlice";
import "../../../i18n";
import { languages } from "../../config/languages";
import { SXDropdown } from "@common/components/ui-components/SXDropdown";
import { useProjects } from "../../features/projects/projectSlice";

interface ShareModalProps {
  isShareModalOpen: boolean;
  user?: any; // Replace 'any' with the actual type of user if known
  sfile?: any; // Replace 'any' with the actual type of sfile if known
}

export const ShareModal = (props: ShareModalProps) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [addUser, setAddUser] = React.useState<{ id: number; name: string } | null>(null);
  const { addUserToFile, removeUserFromFile } = useProjects();
  const handleLanguageSelect = async (langCode: string) => {
    await i18n.changeLanguage(langCode);
  };

  useEffect(() => {
    console.log(props.sfile);
  }, [props.isShareModalOpen]);
  // const currentLanguage = languages.find((lang) => lang.code === i18n.language);

  return (
    <SXModalBase
      header={t("share_file")}
      show={props.isShareModalOpen}
      size="lg"
      close={() => {
        dispatch(closeModal("shareModal"));
      }}
      body={
        <Container>
          <Row style={{ marginBottom: "3rem" }}>
            <Col xs={2}>{t("users")}</Col>
            <Col xs={3}></Col>
          </Row>
          <Row>
            <Col>
              <Row>
                <Col xs={2}>{t("owner")}</Col>
              </Row>
              <Row style={{ marginBottom: "3rem" }}>
                <Col xs={2}>{t("organization")}</Col>
                <Col xs={3}>{(props.user && props.user.user.organization) || "organization missing"}</Col>
              </Row>
              <Row>
                <Col xs={2}>
                  <strong>{t("shared_with")}</strong>{" "}
                </Col>
              </Row>
              {props.sfile?.users?.length > 0 ? (
                props.sfile.users.map((user: any) => (
                  <Row key={user.id}>
                    <Col xs={3}>{user.name}</Col>
                    <Col>
                      <Button
                        onClick={() => {
                          // Implement the logic to remove the user from the shared list
                          removeUserFromFile(props.sfile.guid, user.id);
                          console.log(`Remove user with ID: ${user.id}`);
                        }}
                      >
                        {t("remove")}
                      </Button>
                    </Col>
                  </Row>
                ))
              ) : (
                <Col xs={3}>N/A</Col>
              )}
            </Col>
          </Row>

          <Row>
            <Col xs={2}>{t("add_user")}</Col>
            <Col xs={3}>
              <Form.Select
                className="editfield editfield-border"
                style={{ fontSize: 12 }}
                value={addUser?.name}
                onChange={(e) => {
                  setAddUser({ name: "filip", id: parseInt(e.target.value) });
                }}
              >
                <option value="-1">{t("select")}</option>
                <option value="1">filip</option>
              </Form.Select>
            </Col>
            <Col>
              <button
                onClick={() => {
                  addUserToFile(props.sfile.guid, addUser?.id || 0);
                }}
              >
                {t("add")}
              </button>
            </Col>
          </Row>
        </Container>
      }
      footer={
        <>
          <Button
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("shareModal"));
            }}
          >
            {t("cancel")}
          </Button>
          <Button
            id="disclaimerok"
            className="modal-btn"
            onClick={() => {
              dispatch(closeModal("shareModal"));
            }}
          >
            {t("ok")}
          </Button>
        </>
      }
    />
  );
};
